// extracted by mini-css-extract-plugin
export default {"main":"Baa-z"};